import React from "react";
import pdfContext from "./support/PdfContext";
import ReportButton from "../buttons/ReportButton";
import ReportPreviewButton from "../buttons/ReportPreviewButton";

function ReportCreator(props) {
    const {triggerPdfGeneration} = React.useContext(pdfContext)

    const handleClick = () => {
        triggerPdfGeneration({reportType: props.reportType, reportId: props.id, preview: props.preview, version: props.version})
    }

    return (
        <>
            {props.preview ? <ReportPreviewButton label={props.label} onClick={handleClick}/> : <ReportButton label={props.label} onClick={handleClick}/>}
        </>
    )
}

export default ReportCreator